var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-loader d-flex justify-content-center align-items-center",class:{
    'bg-white': _vm.opaque
  }},[_c('b-spinner',{attrs:{"variant":"primary","label":"Loading..."}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }